var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    { staticClass: "no-padding", attrs: { name: "general" } },
    [
      _c(
        "q-scroll-area",
        {
          staticClass: "full-width customer-card__tab-scroll",
          attrs: {
            "thumb-style": {
              width: "5px",
              "background-color": "#555",
              opacity: 1
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "text-select" },
            [
              _c(
                "q-list",
                { attrs: { "no-border": "" } },
                [
                  _vm.customer.customer_number
                    ? [
                        _c(
                          "q-item",
                          { staticClass: "customer-card__customer-number" },
                          [
                            _c("q-item-side", {
                              staticClass: "customer-card__icon",
                              attrs: { icon: "account_circle", color: "faded" }
                            }),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass:
                                      "customer-card__customer-number-entry",
                                    attrs: { label: "" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.formattedBusinessPartnerType
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass:
                                      "customer-card__payment-deadline-label",
                                    attrs: { sublabel: "" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("business_partner_type")
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          { staticClass: "customer-card__customer-number" },
                          [
                            _c(
                              "q-item-main",
                              { attrs: { inset: "" } },
                              [
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass:
                                      "customer-card__customer-number-entry",
                                    attrs: { label: "" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.customer.customer_number) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass:
                                      "customer-card__payment-deadline-label",
                                    attrs: { sublabel: "" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("customer_number")) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.customer.accounts_receivable_number
                          ? _c(
                              "q-item",
                              { staticClass: "customer-card__customer-number" },
                              [
                                _c(
                                  "q-item-main",
                                  { attrs: { inset: "" } },
                                  [
                                    _c(
                                      "q-item-tile",
                                      {
                                        staticClass:
                                          "customer-card__customer-number-entry",
                                        attrs: { label: "" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.customer
                                                .accounts_receivable_number
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-item-tile",
                                      {
                                        staticClass:
                                          "customer-card__payment-deadline-label",
                                        attrs: { sublabel: "" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "accounts_receivable_number"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.customer.accounts_payable_number
                          ? _c(
                              "q-item",
                              { staticClass: "customer-card__customer-number" },
                              [
                                _c(
                                  "q-item-main",
                                  { attrs: { inset: "" } },
                                  [
                                    _c(
                                      "q-item-tile",
                                      {
                                        staticClass:
                                          "customer-card__customer-number-entry",
                                        attrs: { label: "" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.customer
                                                .accounts_payable_number
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-item-tile",
                                      {
                                        staticClass:
                                          "customer-card__payment-deadline-label",
                                        attrs: { sublabel: "" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("accounts_payable_number")
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("q-item-separator")
                      ]
                    : _vm._e(),
                  _vm.personCompany
                    ? [
                        _c(
                          "q-item",
                          { staticClass: "customer-card__company" },
                          [
                            _c("q-item-side", {
                              staticClass: "customer-card__icon",
                              attrs: { icon: "business", color: "faded" }
                            }),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "customer-card__company-entry",
                                    attrs: { label: "" }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "router-link",
                                        attrs: {
                                          to: {
                                            name: "customer",
                                            params: {
                                              teamId: _vm.activeTeam.id,
                                              customerId: _vm.personCompany.id
                                            }
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.personCompany.name) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("q-item-separator")
                      ]
                    : _vm._e(),
                  _vm.customer.vat_number
                    ? [
                        _c(
                          "q-item",
                          { staticClass: "customer-card__vat-number" },
                          [
                            _c("q-item-side", {
                              staticClass: "customer-card__icon",
                              attrs: { icon: "account_balance", color: "faded" }
                            }),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass:
                                      "customer-card__vat-number-entry",
                                    attrs: { label: "" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.customer.vat_number) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("vat_number")) +
                                      "\n              "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm.customer.tax_number
                    ? [
                        _c(
                          "q-item",
                          { staticClass: "customer-card__vat-number" },
                          [
                            _c(
                              "q-item-main",
                              { attrs: { inset: "" } },
                              [
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass:
                                      "customer-card__tax-number-entry",
                                    attrs: { label: "" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.customer.tax_number) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _c("q-item-tile", { attrs: { sublabel: "" } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("tax_number")) +
                                      "\n              "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm.customer.vat_number || _vm.customer.tax_number
                    ? _c("q-item-separator")
                    : _vm._e(),
                  _vm.customer.website
                    ? [
                        _c(
                          "q-item",
                          { staticClass: "customer-card__website" },
                          [
                            _c("q-item-side", {
                              staticClass: "customer-card__icon",
                              attrs: { icon: "public", color: "faded" }
                            }),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "customer-card__website-entry",
                                    attrs: { label: "" }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.websiteUrl,
                                          target: "_blank",
                                          rel: "noopener noreferrer"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.website))]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("q-item-separator")
                      ]
                    : _vm._e(),
                  _vm.customer.default_payment_deadline
                    ? [
                        _c(
                          "q-item",
                          { staticClass: "customer-card__payment-deadline" },
                          [
                            _c("q-item-side", {
                              staticClass: "customer-card__icon",
                              attrs: { icon: "calendar_today", color: "faded" }
                            }),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass:
                                      "customer-card__payment-deadline-entry",
                                    attrs: { label: "" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.customer.default_payment_deadline
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass:
                                      "customer-card__payment-deadline-label",
                                    attrs: { sublabel: "" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$tc("day", 2)) +
                                        " " +
                                        _vm._s(_vm.$t("payment_deadline")) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("q-item-separator")
                      ]
                    : _vm._e(),
                  _vm.customer.phone_numbers &&
                  _vm.customer.phone_numbers.data.length
                    ? [
                        _vm._l(_vm.customer.phone_numbers.data, function(
                          phoneNumber,
                          index
                        ) {
                          return _c(
                            "q-item",
                            {
                              key: "p_" + phoneNumber.id,
                              staticClass: "customer-card__phone"
                            },
                            [
                              index === 0
                                ? _c("q-item-side", {
                                    staticClass: "customer-card__icon",
                                    attrs: { icon: "phone", color: "faded" }
                                  })
                                : _vm._e(),
                              _c(
                                "q-item-main",
                                { attrs: { inset: index > 0 } },
                                [
                                  _c(
                                    "q-item-tile",
                                    {
                                      staticClass: "customer-card__phone-entry",
                                      attrs: { label: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(phoneNumber.number) +
                                          "\n                "
                                      ),
                                      phoneNumber.id ===
                                      _vm.customer.default_phone_number_id
                                        ? _c("q-icon", {
                                            attrs: {
                                              name: "stars",
                                              color: "faded"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-item-tile",
                                    {
                                      staticClass: "customer-card__phone-label",
                                      attrs: { sublabel: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(phoneNumber.label) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        _c("q-item-separator")
                      ]
                    : _vm._e(),
                  _vm.customer.email_addresses &&
                  _vm.customer.email_addresses.data.length
                    ? [
                        _vm._l(_vm.customer.email_addresses.data, function(
                          emailAddress,
                          index
                        ) {
                          return _c(
                            "q-item",
                            {
                              key: "e_" + emailAddress.id,
                              staticClass: "customer-card__email"
                            },
                            [
                              index === 0
                                ? _c("q-item-side", {
                                    staticClass: "customer-card__icon",
                                    attrs: { icon: "email", color: "faded" }
                                  })
                                : _vm._e(),
                              _c(
                                "q-item-main",
                                { attrs: { inset: index > 0 } },
                                [
                                  _c(
                                    "q-item-tile",
                                    {
                                      staticClass: "customer-card__email-entry",
                                      attrs: { label: "" }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "mailto:" + emailAddress.email
                                          }
                                        },
                                        [_vm._v(_vm._s(emailAddress.email))]
                                      ),
                                      emailAddress.id ===
                                      _vm.customer.default_email_address_id
                                        ? _c("q-icon", {
                                            attrs: {
                                              name: "stars",
                                              color: "faded"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-item-tile",
                                    {
                                      staticClass: "customer-card__email-label",
                                      attrs: { sublabel: "" }
                                    },
                                    [_vm._v(_vm._s(emailAddress.label))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        _c("q-item-separator")
                      ]
                    : _vm._e(),
                  _vm.customer.addresses && _vm.customer.addresses.data.length
                    ? [
                        _vm._l(_vm.customer.addresses.data, function(
                          address,
                          index
                        ) {
                          return _c(
                            "q-item",
                            {
                              key: "a_" + address.id,
                              staticClass: "customer-card__address"
                            },
                            [
                              index === 0
                                ? _c("q-item-side", {
                                    staticClass: "customer-card__icon",
                                    attrs: { icon: "pin_drop", color: "faded" }
                                  })
                                : _vm._e(),
                              _c(
                                "q-item-main",
                                { attrs: { inset: index > 0 } },
                                [
                                  _c(
                                    "q-item-tile",
                                    {
                                      staticClass:
                                        "customer-card__address-entry",
                                      attrs: { label: "" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                address.formatted_address
                                              )
                                            }
                                          }),
                                          address.id ===
                                          _vm.customer.default_address_id
                                            ? _c("q-icon", {
                                                staticClass: "q-pl-md",
                                                attrs: {
                                                  name: "stars",
                                                  color: "faded"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c(
                                    "q-item-tile",
                                    {
                                      staticClass:
                                        "customer-card__address-label",
                                      attrs: { sublabel: "" }
                                    },
                                    [_vm._v(_vm._s(address.label))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        _c("q-item-separator")
                      ]
                    : _vm._e(),
                  _vm.customer.bank_details &&
                  _vm.customer.bank_details.data.length
                    ? [
                        _vm._l(_vm.customer.bank_details.data, function(
                          bankDetails,
                          index
                        ) {
                          return _c(
                            "q-item",
                            {
                              key: "b_" + bankDetails.id,
                              staticClass: "customer-card__bank-details"
                            },
                            [
                              index === 0
                                ? _c("q-item-side", {
                                    staticClass: "customer-card__icon",
                                    attrs: {
                                      icon: "account_balance",
                                      color: "faded"
                                    }
                                  })
                                : _vm._e(),
                              _c(
                                "q-item-main",
                                { attrs: { inset: index > 0 } },
                                [
                                  _c(
                                    "q-item-tile",
                                    {
                                      staticClass:
                                        "customer-card__bank-details-entry",
                                      attrs: { label: "" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  bankDetails.account_number
                                                )
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  bankDetails.bank_identifier
                                                ) +
                                                " " +
                                                _vm._s(bankDetails.bank_name)
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  bankDetails.account_owner
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          bankDetails.id ===
                                          _vm.customer.default_bank_details_id
                                            ? _c("q-icon", {
                                                staticClass: "q-pl-md",
                                                attrs: {
                                                  name: "stars",
                                                  color: "faded"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c(
                                    "q-item-tile",
                                    {
                                      staticClass:
                                        "customer-card__bank-details-label",
                                      attrs: { sublabel: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(bankDetails.label) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        _c("q-item-separator")
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }